import { WidgetBlockName, WidgetInfo } from 'api/types/widgets';
import { widgetIcons } from 'icons';

const iconColors = {
  study: {
    icon: '#3D5DE0',
    bg: '#0548FF0F',
  },
  science: {
    icon: '#01971D',
    bg: '#13D2001C',
  },
  sport: {
    icon: '#866CF6',
    bg: '#230FFF0D',
  },
  creation: {
    icon: '#BB58D4',
    bg: '#AC16CD0F',
  },
  culture: {
    bg: '#FF059B0F',
    icon: '#E2468A',
  },
  civil: {
    bg: '#01C9C121',
    icon: '#0D918F',
  },
  profession: {
    bg: '#12A85D14',
    icon: '#009565',
  },
};
export const WIDGET_BLOCKS: Record<WidgetBlockName, WidgetInfo> = {
  OLYMPIAD: {
    blockName: 'Олимпиада',
    sectionName: 'Учёба',
    icon: widgetIcons.IconWidgetStudyOlympiads,
    iconColor: iconColors.study.icon,
    iconBgColor: iconColors.study.bg,
    link: '/portfolio/student/study#olympiads',
    searchParam: 'olympiadId',
  },
  GIA_EXAM: {
    blockName: 'ГИА',
    sectionName: 'Учёба',
    icon: widgetIcons.IconWidgetStudyGia,
    iconColor: iconColors.study.icon,
    iconBgColor: iconColors.study.bg,
    link: '/portfolio/student/study',
  },
  INDEPENDENT_DIAGNOSIC: {
    blockName: 'Независимая диагностика',
    sectionName: 'Учёба',
    icon: widgetIcons.IconWidgetStudyDiagnostics,
    iconColor: iconColors.study.icon,
    iconBgColor: iconColors.study.bg,
    link: '/portfolio/student/study#diagnostic',
    searchParam: 'independentDiagnosticId',
  },
  INDIVIDUAL_DIAGNOSIC: {
    blockName: 'Индивидуальная диагностика',
    sectionName: 'Учёба',
    icon: widgetIcons.IconWidgetStudyDiagnostics,
    iconColor: iconColors.study.icon,
    iconBgColor: iconColors.study.bg,
    link: '/portfolio/student/study#diagnostic',
    searchParam: 'personalDiagnosticId',
  },
  STUDY_MARK: {
    blockName: 'Предметные результаты',
    sectionName: 'Учёба',
    icon: widgetIcons.IconWidgetStudyResults,
    iconColor: iconColors.study.icon,
    iconBgColor: iconColors.study.bg,
    link: '/portfolio/student/study#performance',
  },
  STUDY_EDUCATION_SPO: {
    blockName: 'Сведения об обучении',
    sectionName: 'Учёба',
    icon: widgetIcons.IconWidgetStudyEducation,
    iconColor: iconColors.study.icon,
    iconBgColor: iconColors.study.bg,
    link: '/portfolio/student/study#spoTraining',
  },
  STUDY_PRACTICE: {
    blockName: 'Практика',
    sectionName: 'Учёба',
    icon: widgetIcons.IconWidgetStudyPractice,
    iconColor: iconColors.study.icon,
    iconBgColor: iconColors.study.bg,
    link: '/portfolio/student/study#practice',
  },

  SCIENCE_REWARD: {
    blockName: 'Награды',
    sectionName: 'Наука',
    icon: widgetIcons.IconWidgetScienceRewards,
    iconColor: iconColors.science.icon,
    iconBgColor: iconColors.science.bg,
    link: '/portfolio/student/science#scienceReward',
  },
  SCIENCE_PROJECT: {
    blockName: 'Проекты',
    sectionName: 'Наука',
    icon: widgetIcons.IconWidgetScienceProjects,
    iconColor: iconColors.science.icon,
    iconBgColor: iconColors.science.bg,
    link: '/portfolio/student/science#projects',
  },
  SCIENCE_EMPLOYMENT: {
    blockName: 'Занятия',
    sectionName: 'Наука',
    icon: widgetIcons.IconWidgetScienceEmployments,
    iconColor: iconColors.science.icon,
    iconBgColor: iconColors.science.bg,
    link: '/portfolio/student/science#scienceEmployments',
  },
  SCIENCE_EVENT: {
    blockName: 'Конкурсы, конференции',
    sectionName: 'Наука',
    icon: widgetIcons.IconWidgetScienceContests,
    iconColor: iconColors.science.icon,
    iconBgColor: iconColors.science.bg,
    link: '/portfolio/student/science#scienceContest',
  },

  SPORT_REWARD: {
    blockName: 'Награды и разряды',
    sectionName: 'Спорт',
    icon: widgetIcons.IconWidgetSportRewards,
    iconColor: iconColors.sport.icon,
    iconBgColor: iconColors.sport.bg,
    link: '/portfolio/student/sport#sportReward',
  },
  SPORT_AFFILATION: {
    blockName: 'Клубы и команды',
    sectionName: 'Спорт',
    icon: widgetIcons.IconWidgetSportClubs,
    iconColor: iconColors.sport.icon,
    iconBgColor: iconColors.sport.bg,
    link: '/portfolio/student/sport#sportClub',
  },
  SPORT_EMPLOYMENT: {
    blockName: 'Кружки и секции',
    sectionName: 'Спорт',
    icon: widgetIcons.IconWidgetSportUnits,
    iconColor: iconColors.sport.icon,
    iconBgColor: iconColors.sport.bg,
    link: '/portfolio/student/sport#sportUnit',
  },
  SPORT_EVENT: {
    blockName: 'Соревнования',
    sectionName: 'Спорт',
    icon: widgetIcons.IconWidgetSportContests,
    iconColor: iconColors.sport.icon,
    iconBgColor: iconColors.sport.bg,
    link: '/portfolio/student/sport#sportGames',
  },
  SPORT_HIKE: {
    blockName: 'Походы и экспедиции',
    sectionName: 'Спорт',
    icon: widgetIcons.IconWidgetSportHikes,
    iconColor: iconColors.sport.icon,
    iconBgColor: iconColors.sport.bg,
    link: '/portfolio/student/sport#hike',
  },

  CREATION_REWARD: {
    blockName: 'Награды и достижения',
    sectionName: 'Творчество',
    icon: widgetIcons.IconWidgetCreationRewards,
    iconColor: iconColors.creation.icon,
    iconBgColor: iconColors.creation.bg,
    link: '/portfolio/student/creation#creationReward',
  },
  CREATION_AFFILATION: {
    blockName: 'Творческие коллективы',
    sectionName: 'Творчество',
    icon: widgetIcons.IconWidgetCreationCollectives,
    iconColor: iconColors.creation.icon,
    iconBgColor: iconColors.creation.bg,
    link: '/portfolio/student/creation#creationClub',
  },
  CREATION_EVENT: {
    blockName: 'Конкурсы',
    sectionName: 'Творчество',
    icon: widgetIcons.IconWidgetCreationContests,
    iconColor: iconColors.creation.icon,
    iconBgColor: iconColors.creation.bg,
    link: '/portfolio/student/creation#creationContest',
  },
  CREATION_EMPLOYMENT: {
    blockName: 'Кружки',
    sectionName: 'Творчество',
    icon: widgetIcons.IconWidgetCreationUnits,
    iconColor: iconColors.creation.icon,
    iconBgColor: iconColors.creation.bg,
    link: '/portfolio/student/creation#creationUnit',
  },

  CULTURE_VISIT: {
    blockName: 'Посещение учреждений',
    sectionName: 'Культура',
    icon: widgetIcons.IconWidgetCultureOfflineEvents,
    iconColor: iconColors.culture.icon,
    iconBgColor: iconColors.culture.bg,
    link: '/portfolio/student/culture#offlineVisit',
  },
  CULTURE_EVENT: {
    blockName: 'Онлайн-мероприятия',
    sectionName: 'Культура',
    icon: widgetIcons.IconWidgetCultureOnlineEvents,
    iconColor: iconColors.culture.icon,
    iconBgColor: iconColors.culture.bg,
    link: '/portfolio/student/culture#offlineVisit',
  },

  CIVIL_REWARD: {
    blockName: 'Награды и статусы',
    sectionName: 'Гр. активность',
    icon: widgetIcons.IconWidgetCivilRewards,
    iconColor: iconColors.civil.icon,
    iconBgColor: iconColors.civil.bg,
    link: '/portfolio/student/civil#civilReward',
  },
  CIVIL_AFFILATION: {
    blockName: 'Клубы',
    sectionName: 'Гр. активность',
    icon: widgetIcons.IconWidgetCivilClubs,
    iconColor: iconColors.civil.icon,
    iconBgColor: iconColors.civil.bg,
    link: '/portfolio/student/civil#civilClub',
  },
  CIVIL_EVENT: {
    blockName: 'Конкурсы, соревнования',
    sectionName: 'Гр. активность',
    icon: widgetIcons.IconWidgetCivilContests,
    iconColor: iconColors.civil.icon,
    iconBgColor: iconColors.civil.bg,
    link: '/portfolio/student/civil#civilContest',
  },
  CIVIL_EMPLOYMENT: {
    blockName: 'Кружки',
    sectionName: 'Гр. активность',
    icon: widgetIcons.IconWidgetCivilUnits,
    iconColor: iconColors.civil.icon,
    iconBgColor: iconColors.civil.bg,
    link: '/portfolio/student/civil#civilUnit',
  },

  PROFESSION_REWARD: {
    blockName: 'Награды',
    sectionName: 'Моя профессия',
    icon: widgetIcons.IconWidgetProfessionRewards,
    iconColor: iconColors.profession.icon,
    iconBgColor: iconColors.profession.bg,
    link: '/portfolio/student/profession#professionRewards',
  },
  PROFESSION_EDUCATION: {
    blockName: 'Проф. обучение',
    sectionName: 'Моя профессия',
    icon: widgetIcons.IconWidgetProfessionEducation,
    iconColor: iconColors.profession.icon,
    iconBgColor: iconColors.profession.bg,
    link: '/portfolio/student/profession#professionEducation',
  },
  PROFESSION_EVENT: {
    blockName: 'Мероприятия',
    sectionName: 'Моя профессия',
    icon: widgetIcons.IconWidgetProfessionEvents,
    iconColor: iconColors.profession.icon,
    iconBgColor: iconColors.profession.bg,
    link: '/portfolio/student/profession#professionEvents',
  },
  PROFESSION_JOB: {
    blockName: 'Трудоустройство',
    sectionName: 'Моя профессия',
    icon: widgetIcons.IconWidgetProfessionJobs,
    iconColor: iconColors.profession.icon,
    iconBgColor: iconColors.profession.bg,
    link: '/portfolio/student/profession#professionJob',
  },
  PROFESSION_APPLICATION: {
    blockName: 'Профориентация',
    sectionName: 'Моя профессия',
    icon: widgetIcons.IconWidgetProfessionProforientation,
    iconColor: iconColors.profession.icon,
    iconBgColor: iconColors.profession.bg,
    link: '/portfolio/student/profession#professionProforientation',
  },
};

export const WIDGET_BLOCK_NAME_TO_SECTION_TYPE_CODE: Record<WidgetBlockName, string> = {
  OLYMPIAD: 'studies.olympiads',
  GIA_EXAM: 'studies.gia',
  INDEPENDENT_DIAGNOSIC: 'studies.diagnostics',
  INDIVIDUAL_DIAGNOSIC: 'studies.diagnostics',
  STUDY_MARK: 'studies.performance',
  STUDY_EDUCATION_SPO: 'studies.study_training',
  STUDY_PRACTICE: 'studies.study_practice',
  SCIENCE_REWARD: 'science.rewards',
  SCIENCE_PROJECT: 'science.projects',
  SCIENCE_EMPLOYMENT: 'science.employments',
  SCIENCE_EVENT: 'science.contests',
  SPORT_REWARD: 'sport.rewards',
  SPORT_AFFILATION: 'sport.clubs',
  SPORT_EMPLOYMENT: 'sport.units',
  SPORT_EVENT: 'sport.sport_games',
  SPORT_HIKE: 'sport.hike',
  CREATION_REWARD: 'creation.rewards',
  CREATION_AFFILATION: 'creation.creation_club',
  CREATION_EVENT: 'creation.creation_contest',
  CREATION_EMPLOYMENT: 'creation.creation_unit',
  CULTURE_VISIT: 'culture.offline_visit',
  CULTURE_EVENT: 'culture.online_visit',
  CIVIL_REWARD: 'civil.rewards',
  CIVIL_AFFILATION: 'civil.civil_club',
  CIVIL_EVENT: 'civil.civil_contest',
  CIVIL_EMPLOYMENT: 'civil.civil_unit',
  PROFESSION_REWARD: 'profession.profession_rewards',
  PROFESSION_EDUCATION: 'profession.profession_education',
  PROFESSION_EVENT: 'profession.profession_events',
  PROFESSION_JOB: 'profession.profession_job',
  PROFESSION_APPLICATION: 'profession.applications',
};
